<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 11 20"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.733519 9.29402C1.1385 8.9035 1.7951 8.9035 2.20007 9.29402L10.2651 17.0712C10.6701 17.4617 10.6701 18.0949 10.2651 18.4854C9.86011 18.8759 9.20351 18.8759 8.79853 18.4854L0.733519 10.7082C0.328542 10.3177 0.328542 9.68454 0.733519 9.29402Z" :fill="fill"/>
    <rect :fill="fill" height="2.03735" rx="1.01867" transform="matrix(-0.719836 0.694145 -0.719835 -0.694145 11 2.22217)" width="13.2435"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronLeft',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
